import { Node } from 'reactflow'

import { compareArraysOfObjects, compareSets } from '@ui/lib/utils'
import { create } from 'zustand'
import { combine } from 'zustand/middleware'

interface SaveUpdateStatus {
  pipelineModified: boolean
  saveButtonEnabled: boolean
  pipelineNodes: Node[]
  assignedSourceIds: Set<number>
}

const defaultValues: SaveUpdateStatus = {
  pipelineModified: false,
  saveButtonEnabled: false,
  pipelineNodes: [],
  assignedSourceIds: new Set(),
}

export const useSaveUpdateStatusStore = create(
  combine(defaultValues, (set, get) => ({
    setPipelineModified: (pipelineModified: boolean) => set({ pipelineModified }),
    setPipelineNodes: (pipelineNodes: Node[]) => set({ pipelineNodes }),
    handlePipelineModified: (nodes: Node[]) => {
      const filterAndMapNodes = (nodes: Node[]) =>
        nodes.filter((node) => node.type !== 'placeholder').map((node) => ({ id: node.id }))

      const nodeIds = filterAndMapNodes(nodes)
      const pipelineIdsSnapshot = filterAndMapNodes(get().pipelineNodes)

      // Compare modified nodes array to original nodes
      const isModified = compareArraysOfObjects(nodeIds, pipelineIdsSnapshot)
      set({ pipelineModified: !isModified })
    },
    setSaveButtonEnabled: (saveButtonEnabled: boolean) => set({ saveButtonEnabled }),
    setAssignedSourceIds: ({
      assignedSourceIds,
      updatePipelineModified,
    }: {
      assignedSourceIds: Set<number>
      updatePipelineModified: boolean
    }) => {
      const areSetsTheSame = compareSets(get().assignedSourceIds, assignedSourceIds)
      const pipelineModified = updatePipelineModified ? !areSetsTheSame : get().pipelineModified

      set({
        assignedSourceIds,
        pipelineModified,
      })
    },
  }))
)
